import { QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { ToastProvider } from "@vjal/ui";
import { createCoachingQueryClient } from "./lib/query-client";
import { WalkReadinessProvider } from "./lib/walk-readiness";

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createCoachingQueryClient);

  // ToastProvider mounts at the root so every product page can call useToast()
  // (the Wave 1 CRUD pages toast on every successful mutation). Toasts surface
  // only after the backend confirms a write — never an implied success.
  return (
    <QueryClientProvider client={queryClient}>
      <WalkReadinessProvider>
        <ToastProvider>{children}</ToastProvider>
      </WalkReadinessProvider>
    </QueryClientProvider>
  );
}
